import { rtkApi } from '@/shared/api';
import { SuccessApiResponse } from '@/shared/types/common';
import { GET_STUDENT_SCORM, GET_TEACHER_SCORM } from '@/shared/api/tags';
import type {
  IStudentScormRequest,
  IStudentScormResponse,
  ITeacherScormRequest,
  ITeacherScormResponse,
  IStudentScormLaunchRequest,
  IStudentScormLaunchResponse,
  IScormPreviewRequest,
  IScormPreviewResponse,
  IScormReviewRequest,
  IScormReviewResponse,
} from './types';

const scormApi = rtkApi.injectEndpoints({
  endpoints: (build) => ({
    getScorm: build.query<IStudentScormResponse, IStudentScormRequest>({
      query: (params) => ({
        url: '/student/assignments/scorm',
        params,
      }),
      transformResponse: (response: SuccessApiResponse<IStudentScormResponse>) => response.data,
      providesTags: [GET_STUDENT_SCORM],
    }),
    getScormLaunch: build.query<IStudentScormLaunchResponse, IStudentScormLaunchRequest>({
      query: (params) => ({
        url: '/scorm/launch',
        params,
      }),
      transformResponse: (response: SuccessApiResponse<IStudentScormLaunchResponse>) =>
        response.data,
    }),
    getScormPreview: build.query<IScormPreviewResponse, IScormPreviewRequest>({
      query: ({ packageId, scoIdentifier }) => ({
        url: `/scorm/preview/${packageId}`,
        params:
          scoIdentifier !== undefined && scoIdentifier !== null
            ? { scoIdentifier }
            : undefined,
      }),
      transformResponse: (response: SuccessApiResponse<IScormPreviewResponse>) => response.data,
    }),
    getScormReview: build.query<IScormReviewResponse, IScormReviewRequest>({
      query: (params) => ({
        url: '/scorm/review',
        params,
      }),
      transformResponse: (response: SuccessApiResponse<IScormReviewResponse>) => response.data,
    }),
    getTeacherScorm: build.query<ITeacherScormResponse, ITeacherScormRequest>({
      query: (params) => ({
        url: '/teacher/assignments/scorm',
        params,
      }),
      transformResponse: (response: SuccessApiResponse<ITeacherScormResponse>) => response.data,
      providesTags: [GET_TEACHER_SCORM],
    }),
  }),
});

export const {
  useGetScormQuery,
  useLazyGetScormLaunchQuery,
  useGetTeacherScormQuery,
  useGetScormPreviewQuery,
  useLazyGetScormPreviewQuery,
  useGetScormReviewQuery,
  useLazyGetScormReviewQuery,
} = scormApi;
